function EnrolleeFrp(aAddress, aEnrollee) {
    "use strict";
    this.__type = 'EnrolleeFrp:www.veritracks.com';

    this.Id = -1;
    this.EnrolleeId = 0;
    this.FirstName = "";
    this.LastName = "";
    this.Street1 = "";
    this.Street2 = "";
    this.City = "";
    this.State = "";
    this.Country = "";
    this.Zip = "";
    this.PhoneNumber = "";
    this.PhoneNumber2 = "";
    this.IsActive = true;
    this.Email = "";

    if (aAddress) {
        this.City = aAddress.City;
        this.Country = aAddress.Country;
        this.State = aAddress.State;
        this.Zip = aAddress.Zip;
        this.Street1 = aAddress.Street1;
        this.Street2 = aAddress.Street2;
    }//end of if

    if (aEnrollee) {
        this.EnrolleeId = aEnrollee.Id;
    }//end of if
}
if (typeof exports !== 'undefined') {
    module.exports = EnrolleeFrp;
}